module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"roc_curve":"ROC Curve"},"fr":{"roc_curve":"Courbe ROC"}}')
  delete Component.options._Ctor
}
